'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Navbar = require('../../Navbar.js');
var index = require('../../../../../node_modules/classnames/index.js');
require('./NavLink.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var NavLink = function (props) {
    var item = props.item, onMouseOver = props.onMouseOver, onMouseLeave = props.onMouseLeave, _a = props.isWithStyle, isWithStyle = _a === void 0 ? false : _a, _b = props.isSelected, isSelected = _b === void 0 ? false : _b, _c = props.isDesktop, isDesktop = _c === void 0 ? false : _c, _d = props.parentHasDropdown, parentHasDropdown = _d === void 0 ? false : _d, level = props.level;
    var _e = Navbar.useNavbarContext(), linkComponent = _e.linkComponent, logoutAction = _e.logoutAction;
    if (!linkComponent && item.type !== 'spa') {
        return (React__default['default'].createElement(LinkElement, { item: item, isWithStyle: isWithStyle, isSelected: isSelected, isDesktop: isDesktop, parentHasDropdown: parentHasDropdown, level: level, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave, logoutAction: logoutAction }));
    }
    return linkComponent(React__default['default'].createElement(LinkElement, { item: item, isWithStyle: isWithStyle, isSelected: isSelected, isDesktop: isDesktop, parentHasDropdown: parentHasDropdown, level: level, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave, logoutAction: logoutAction }), item);
};
var LinkElement = function (props) {
    var item = props.item, onMouseOver = props.onMouseOver, onMouseLeave = props.onMouseLeave, _a = props.isSelected, isSelected = _a === void 0 ? false : _a, _b = props.isDesktop, isDesktop = _b === void 0 ? false : _b, _c = props.parentHasDropdown, parentHasDropdown = _c === void 0 ? false : _c, level = props.level, logoutAction = props.logoutAction;
    var itemClass;
    var switchClass = function (level) {
        switch (level) {
            case 0:
                itemClass = 'primary_nav_link';
                break;
            case 1:
                itemClass = 'secondary_nav_link';
                break;
            case 2:
                itemClass = 'tertiary_nav_link';
                break;
            default:
                itemClass = '';
        }
        return itemClass;
    };
    return parentHasDropdown ? (React__default['default'].createElement("a", { href: isDesktop ? item.link : null, title: item.title, className: index['default'](switchClass(level), isSelected && 'selected', item.isButtonStyleType ? 'style_button' : ''), onTouchEnd: isDesktop ? null : isSelected ? onMouseLeave : onMouseOver, onMouseOver: isDesktop ? onMouseOver : null },
        item.isButtonStyleType && (React__default['default'].createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", viewBox: "0 0 40 40", className: 'style_button' },
            React__default['default'].createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M36 20C36 28.8366 28.8366 36 20 36C11.1634 36 4 28.8366 4 20C4 11.1634 11.1634 4 20 4C28.8366 4 36 11.1634 36 20ZM24 14C24 16.2091 22.2091 18 20 18C17.7909 18 16 16.2091 16 14C16 11.7909 17.7909 10 20 10C22.2091 10 24 11.7909 24 14ZM19.9999 22C15.9648 22 12.4879 24.3899 10.9075 27.8314C13.1081 30.3841 16.3653 32 20 32C23.6346 32 26.8917 30.3841 29.0923 27.8316C27.5119 24.39 24.035 22 19.9999 22Z" }))),
        React__default['default'].createElement("span", { className: index['default'](item.isButtonStyleType ? 'style_button' : '') }, item.title),
        React__default['default'].createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "17", height: "16", viewBox: "0 0 17 16", fill: "none", className: index['default'](item.isButtonStyleType ? 'style_button' : '') },
            React__default['default'].createElement("path", { d: "M8.55553 9.98334C8.46664 9.98334 8.38064 9.96667 8.29753 9.93334C8.21398 9.9 8.14442 9.85556 8.08887 9.8L5.0222 6.73334C4.89998 6.61111 4.83887 6.45556 4.83887 6.26667C4.83887 6.07778 4.89998 5.92222 5.0222 5.8C5.14442 5.67778 5.29998 5.61667 5.48887 5.61667C5.67776 5.61667 5.83331 5.67778 5.95553 5.8L8.55553 8.4L11.1555 5.8C11.2778 5.67778 11.4333 5.61667 11.6222 5.61667C11.8111 5.61667 11.9666 5.67778 12.0889 5.8C12.2111 5.92222 12.2722 6.07778 12.2722 6.26667C12.2722 6.45556 12.2111 6.61111 12.0889 6.73334L9.0222 9.8C8.95553 9.86667 8.88331 9.91378 8.80553 9.94134C8.72776 9.96934 8.64442 9.98334 8.55553 9.98334Z" })))) : (React__default['default'].createElement("a", { href: item.link, title: item.title, className: index['default'](switchClass(level), isSelected && 'selected'), onClick: function (e) {
            if (item.type === 'prevent' || item.type === 'spa') {
                e.preventDefault();
            }
            if (item.title === 'Keluar') {
                logoutAction();
                return;
            }
            item.onClick && item.onClick(item);
        } },
        React__default['default'].createElement("span", null, item.title)));
};

exports.NavLink = NavLink;
//# sourceMappingURL=NavLink.js.map
